import { useEffect, useState } from 'react';

import Menu from '../../components/MenuOvoCaipira.jsx';
import constantes from '../../helpers/constanteHelper.js';

import sheetsService from '../../services/sheetsServiceOvoCaipira.js'
import ProdutosPorClassificacao from '../../components/ProdutosPorClassificacaoGenerico.jsx';
import FiltrosProdutosOvoCaipira from '../../components/FiltrosProdutosOvoCaipira.jsx';
import TituloNegrito from '../../components/TituloNegrito.jsx';

function CatalogoOvoCaipiraProdutos() {
    const [width, setWidth] = useState(window.innerWidth);
    const [produtosSemFiltro, setProdutosSemFiltro] = useState({});
    const [produtos, setProdutos] = useState({});
    const [tipoVisualizacao, setTipoVisualizacao] = useState('Por empresa');

    // Filtros
    const [filtroTema, setFiltroTema] = useState();
    const [filtroEspecie, setFiltroEspecie] = useState();
    const [filtroCategoria, setFiltroCategoria] = useState();

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        sheetsService.buscarDadosProdutos().then((produtosBuscados) => {
            setProdutosSemFiltro(produtosBuscados)
            setProdutos(produtosBuscados)
        })
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    function aplicarFiltros(tema, especie, categoria) {
        if (tema === '' && especie === '' && categoria === '' || !tema && !especie && !categoria) {
            setProdutos(produtosSemFiltro)
        } else {
            // Reset de filtros
            const produtosFiltrados = structuredClone(produtosSemFiltro)

            // Empresas
            for (let i = 0; i < Object.keys(produtosFiltrados.produtosPorEmpresa).length; i++) {

                // Filtrando por tema, caso o filtro esteja preenchido
                if (tema && tema !== '') {
                    produtosFiltrados.produtosPorEmpresa[Object.keys(produtosFiltrados.produtosPorEmpresa)[i]] =
                        produtosFiltrados.produtosPorEmpresa[Object.keys(produtosFiltrados.produtosPorEmpresa)[i]].filter((produto) => produto['Tema'] === tema)
                }

                // Filtrando por espécie, caso o filtro esteja preenchido
                if (especie && especie !== '') {
                    produtosFiltrados.produtosPorEmpresa[Object.keys(produtosFiltrados.produtosPorEmpresa)[i]] =
                        produtosFiltrados.produtosPorEmpresa[Object.keys(produtosFiltrados.produtosPorEmpresa)[i]].filter((produto) => produto[especie] === 'X' || produto[especie] === 'x')
                }

                // Filtrando por categoria, caso o filtro esteja preenchido
                if (categoria && categoria !== '') {
                    produtosFiltrados.produtosPorEmpresa[Object.keys(produtosFiltrados.produtosPorEmpresa)[i]] =
                        produtosFiltrados.produtosPorEmpresa[Object.keys(produtosFiltrados.produtosPorEmpresa)[i]].filter((produto) => produto['Categoria'].replaceAll('</em>', '').replaceAll('<em>', '') === categoria)
                }

            }

            // Por categoria
            for (let i = 0; i < Object.keys(produtosFiltrados.produtosPorCategoria).length; i++) {

                // Filtrando por tema, caso o filtro esteja preenchido
                if (tema && tema !== '') {
                    produtosFiltrados.produtosPorCategoria[Object.keys(produtosFiltrados.produtosPorCategoria)[i]] =
                        produtosFiltrados.produtosPorCategoria[Object.keys(produtosFiltrados.produtosPorCategoria)[i]].filter((produto) => produto['Tema'] === tema)
                }

                // Filtrando por espécie, caso o filtro esteja preenchido
                if (especie && especie !== '') {
                    produtosFiltrados.produtosPorCategoria[Object.keys(produtosFiltrados.produtosPorCategoria)[i]] =
                        produtosFiltrados.produtosPorCategoria[Object.keys(produtosFiltrados.produtosPorCategoria)[i]].filter((produto) => produto[especie] === 'X' || produto[especie] === 'x')
                }

                // Filtrando por categoria, caso o filtro esteja preenchido
                if (categoria && categoria !== '') {
                    produtosFiltrados.produtosPorCategoria[Object.keys(produtosFiltrados.produtosPorCategoria)[i]] =
                        produtosFiltrados.produtosPorCategoria[Object.keys(produtosFiltrados.produtosPorCategoria)[i]].filter((produto) => produto['Categoria'].replaceAll('</em>', '').replaceAll('<em>', '') === categoria)
                }
            }


            setProdutos(produtosFiltrados)
        }

    }

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.MARROM_OVO_CAIPIRA }} className='d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'produtos'} />
                <TituloNegrito texto={'Filtros'} />

                <FiltrosProdutosOvoCaipira
                    setTipoVisualizacao={setTipoVisualizacao}
                    temas={produtos.temas}
                    especies={produtos.especies}
                    categorias={produtos.categorias}
                    aplicarFiltros={aplicarFiltros}
                    filtroTema={filtroTema}
                    setFiltroTema={setFiltroTema}
                    filtroEspecie={filtroEspecie}
                    setFiltroEspecie={setFiltroEspecie}
                    filtroCategoria={filtroCategoria}
                    setFiltroCategoria={setFiltroCategoria}
                />

                <div className='d-flex flex-column align-items-center'>
                    {tipoVisualizacao === 'Por empresa' ?
                        <ProdutosPorClassificacao produtos={produtos.produtosPorEmpresa} resolucaoMobile={resolucaoMobile} pathCatalogo={'catalogo-ovo-caipira'} /> :
                        tipoVisualizacao === 'Por espécie' ?
                            <ProdutosPorClassificacao produtos={produtos.produtosPorEspecie} resolucaoMobile={resolucaoMobile} especie={filtroEspecie} pathCatalogo={'catalogo-ovo-caipira'} /> :
                            tipoVisualizacao === 'Por tema' ?
                                <ProdutosPorClassificacao produtos={produtos.produtosPorTema} resolucaoMobile={resolucaoMobile} pathCatalogo={'catalogo-ovo-caipira'} /> :
                                <ProdutosPorClassificacao produtos={produtos.produtosPorCategoria} resolucaoMobile={resolucaoMobile} pathCatalogo={'catalogo-ovo-caipira'} />}
                </div>
                
                <div style={{height: '50px'}}></div>
            </div>
        </>
    );
}

export default CatalogoOvoCaipiraProdutos;
